import createDataContext from './createDataContext';
import API, { ALLOWED_USERS, prodUrl } from '../apiConfig';
import { parseJwt } from '../utils/commonFunctions';
import { Mixpanel } from '../utils/mixpanel';


const token = JSON.parse(localStorage.getItem('token'));
const userData = token && Object.keys(token).length !== 0
    ? { ...parseJwt(token.accessToken), isSelfDelivery: parseInt(localStorage.getItem('isSelfDelivery') || '0') }
    : null;

const roleObject = {
    woSeller: false,
    woDistributor:false
}

const roleObj = () => {
    if (userData && userData.role) {
        getAccessRoles(userData.role);
        return roleObject;
    }
}

const authReducer = (state, action) => {
    switch (action.type) {
        default:
            return state;
        case 'loggedIn':
            return { loggedIn: action.payload };
        case 'userData':
            return { ...state, userData: action.payload };
        case 'roleObj':
            return { ...state, roleCheck: action.payload }

    }
};

const checkAuth = dispatch => async () => {

    if (userData) {
        dispatch({ type: 'userData', payload: userData });
        Mixpanel.identify(userData.user_id);
        Mixpanel.people.set({
            email: userData.email,
            name: userData.name,
            phone_number: userData.phone_number,
            store_type: userData.store_type,
            store_category: userData.store_category,
            user_id: userData.user_id,
            zone: userData.zone,
        })
        if (prodUrl.includes(window.location.hostname) && ALLOWED_USERS.includes(userData?.phone_number)) {
            document.body.classList.remove('dev');  
            document.body.classList.add('prod');
        } 
    }
    else {
        dispatch({ type: 'userData', payload: null });
    }
}

const signin = (dispatch) => {
    return async ({ username, otp,isWoSeller }) => {
        try {
            const response = await API.post('/user/seller/login', { username, otp,isWoSeller }, { withCredentials: false });
            if (response.data.status === 'success') {
                getAccessRoles(response.data.login_data.role);
                localStorage.setItem('token', JSON.stringify(response.data.token));
                localStorage.setItem('isSelfDelivery', response.data.login_data.isSelfDelivery ?? 0);
                let userData = { ...parseJwt(response.data.token.accessToken), isSelfDelivery: response.data.login_data.isSelfDelivery ?? 0 };
                dispatch({ type: 'userData', payload: userData });
                dispatch({ type: 'roleObj', payload: roleObject })
                if (prodUrl.includes(window.location.hostname) && ALLOWED_USERS.includes(userData?.phone_number)) {
                    document.body.classList.remove('dev');
                    document.body.classList.add('prod');
                }
                return response.data.status
            }
            else {
                return response
            }
        }
        catch (err) {
            alert(err)
        }
    }
}

const updateSignin = (dispatch) => {
    return async (data) => {
        try {
            const response = await API.post('user/seller/gopos-login', data, { withCredentials: false });
            if (response && response.data.status === 'success') {
                getAccessRoles(response.data.login_data.role);
                localStorage.setItem('token', JSON.stringify(response.data.token));
                localStorage.setItem('isSelfDelivery', response.data.login_data.isSelfDelivery ?? 0);
                let userData = { ...parseJwt(response.data.token.accessToken), isSelfDelivery: response.data.login_data.isSelfDelivery ?? 0 };
                dispatch({ type: 'userData', payload: userData });
                dispatch({ type: 'roleObj', payload: roleObject })
                return response.data.status
            }
            else {
                return response
            }
        }
        catch (err) {
            alert(err)
        }
    }
}

const signup = (dispatch) => {
    return async (data) => {
        try {
            const response = await API.post('user/v1/seller/verifyotp', data, { withCredentials: false });
            if (response && response.data && response.data.status === 'success') {
                return response
            }
            else {
                return response
            }
        }
        catch (err) {
            alert(err)
        }
    }
}

const logout = (dispatch) => {
    return async () => {
        localStorage.clear();
        try {
            const response = await API.get('user/seller/logout');
            let roleObject = {
                woSeller: false
            }
            dispatch({ type: 'roleObj', payload: roleObject });
            Mixpanel.reset();
            return response.data.status
        }
        catch (err) {
            return null
        }
    }
}

function getAccessRoles(role) {
    switch (role) {
        case 'WO_SELLER': {
            return roleObject.woSeller = true;
        }
        case 'WO_DISTRIBUTOR': {
            return roleObject.woDistributor = true;
        }
        default:
            return null;
    }
}

export const { Provider, Context } = createDataContext(
    authReducer,
    { signin, checkAuth, logout, roleObj, signup, updateSignin },
    { roleObj: roleObject, userData: userData },
)
